import { TextField, Alert, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
function UserEditForm({
  handleClose,
  dataToAlter,
  onTextfieldChangeHandler,
  disableForm,
  editUserHandler,
  errorMessages,
}) {
  return (
    <div>
      <Typography variant="body1">
        Edit record for {dataToAlter.name}?
      </Typography>
      <div className="users-modal-textfields">
        <TextField
          label="name"
          name="name"
          aria-label="name"
          aria-required="true"
          onChange={onTextfieldChangeHandler}
          defaultValue={dataToAlter.name}
        />
        <TextField
          label="email"
          name="email"
          aria-label="email"
          aria-required="true"
          onChange={onTextfieldChangeHandler}
          defaultValue={dataToAlter.email}
        />
      </div>
      {errorMessages.length !== 0 &&
        errorMessages.map((item, index) => {
          return (
            <Alert
              severity="warning"
              key={`edit-error-${index}`}
              className="users-form-warning"
            >
              {item}
            </Alert>
          );
        })}
      <div className="users-modal-buttons">
        <Button className="siteBlueOutlined" onClick={handleClose}>
          cancel
        </Button>
        <Button
          disabled={disableForm}
          className="siteBlue"
          onClick={editUserHandler}
        >
          confirm edits
        </Button>
      </div>
    </div>
  );
}
UserEditForm.propTypes = {
  handleClose: PropTypes.func,
  dataToAlter: PropTypes.object,
  onTextfieldChangeHandler: PropTypes.func,
  disableForm: PropTypes.bool,
  editUserHandler: PropTypes.func,
  errorMessages: PropTypes.array,
};
export default UserEditForm;
